import { useState, useEffect } from "react";
import { HeartHandshake, EyeOff, MessageCircleOff, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

export default function SupporterOnboarding() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user?.account_type === "supporter") {
      const key = `haplap_supporter_onboarded_${user.user_id}`;
      if (!localStorage.getItem(key)) setOpen(true);
    }
  }, [user]);

  const done = () => {
    if (user) localStorage.setItem(`haplap_supporter_onboarded_${user.user_id}`, "1");
    setOpen(false);
  };

  const rows = [
    { icon: EyeOff, title: "You're invisible by default", text: "You won't appear in browse or search, and no one can see who you help." },
    { icon: HeartHandshake, title: "Give anonymously", text: "Your name is hidden on every gift unless you choose to show it — you're always in control." },
    { icon: MessageCircleOff, title: "Messages, your way", text: "Turn private messages on or off anytime in your profile settings. No spam, ever." },
  ];

  return (
    <Dialog open={open} onOpenChange={(o) => !o && done()}>
      <DialogContent data-testid="supporter-onboarding" className="sm:max-w-md rounded-3xl text-center">
        <div className="w-14 h-14 rounded-full bg-sage/15 mx-auto flex items-center justify-center text-sage"><Sparkles className="w-7 h-7" /></div>
        <DialogTitle className="font-serif text-2xl font-bold text-bronze mt-3">Welcome, kind soul 💛</DialogTitle>
        <p className="text-muted-foreground text-sm mt-1">Thank you for being here to help. Here's how we keep you safe and private:</p>
        <div className="space-y-3 mt-5 text-left">
          {rows.map((r) => (
            <div key={r.title} className="flex gap-3 items-start bg-secondary/50 rounded-2xl p-3">
              <div className="w-9 h-9 rounded-full bg-card flex items-center justify-center text-copper shrink-0"><r.icon className="w-4.5 h-4.5" /></div>
              <div><p className="font-semibold text-sm text-bronze">{r.title}</p><p className="text-xs text-foreground/70">{r.text}</p></div>
            </div>
          ))}
        </div>
        <Button data-testid="onboarding-done" onClick={done} className="w-full mt-5 rounded-full bg-copper hover:bg-copper/90 text-white py-6">Got it — let's help someone 💛</Button>
      </DialogContent>
    </Dialog>
  );
}
